import React, { useState } from "react";
import useOnScreen from "../../hooks/useOnScreen";

const faqItems = [
  {
    id: "faq-1",
    question: "Cocok untuk pemula yang belum pernah test IELTS?",
    answerParts: [
      { text: "Sangat cocok.", bold: true },
      { text: "Program kami dirancang dari" },
      { text: "basic hingga strategi", bold: true },
      { text: "lanjutan, jadi kamu tetap bisa mulai meskipun dari nol." },
    ],
  },
  {
    id: "faq-2",
    question: "Bagaimana kalau tidak bisa hadir live class?",
    answerParts: [
      { text: "Tenang, kamu" },
      { text: "tetap bisa ikut", bold: true },
      { text: "lewat rekaman kelas yang bisa" },
      { text: "diakses kapan saja", bold: true },
      { text: ", jadi nggak akan ketinggalan materi." },
    ],
  },
  {
    id: "faq-3",
    question: "Apakah ada jaminan skor naik?",
    answerParts: [
      { text: "Program ini dirancang untuk" },
      { text: "bantu kamu naik skor", bold: true },
      { text: "secara optimal, dengan latihan dan" },
      { text: "strategi yang tepat", bold: true },
      { text: "." },
    ],
  },
  {
    id: "faq-4",
    question: "Apa itu IELTS ?",
    answerParts: [
      { text: "IELTS (International English Language Testing System) adalah tes bahasa Inggris yang digunakan untuk mengukur kemampuan bahasa Inggris seseorang." },
      { text: "Tes ini biasanya diambil oleh orang yang ingin studi di luar negeri atau bekerja di lingkungan internasional." },
    ],
  },
  {
    id: "faq-5",
    question: "Apa perbedaan antara IELTS Academic dan IELTS General Training?",
    answerParts: [
      { text: "IELTS Academic", bold: true },
      { text: " dirancang untuk mereka yang ingin mendaftar di program pendidikan universitas atau profesional. Sementara" },
      { text: "IELTS General Training", bold: true },
      { text: " lebih cocok untuk mereka yang ingin bekerja atau migrasi ke negara dengan bahasa Inggris." },
    ],
  },
  {    id: "faq-6",
    question: "Apa saja yang dipelajari dalam kelas IELTS Preparation di ScholarsToday?",
    answerParts: [
      { text: "Dalam kelas IELTS Preparation di ScholarsToday, kamu akan mempelajari semua aspek tes IELTS, termasuk Listening, Reading, Writing, dan Speaking. Materi disusun secara terstruktur untuk membantu kamu memahami format tes dan mengembangkan strategi yang efektif untuk setiap bagian." },
    ],
  },
  {
    id: "faq-7",
    question: "Berapa lama durasi program IELTS Preparation di ScholarsToday?",
    answerParts: [
      { text: "Durasi program IELTS Preparation di ScholarsToday biasanya berlangsung selama 8 minggu, dengan sesi live class setiap minggu. Namun, kamu juga akan memiliki akses ke rekaman kelas dan materi tambahan untuk belajar secara fleksibel sesuai kebutuhanmu." },
    ],
  },
  { id: "faq-8",
    question: "Apakah ada tes penempatan sebelum mengikuti program IELTS Preparation?",
    answerParts: [
      { text: "Ya, kami melakukan tes penempatan untuk memastikan kamu masuk ke kelas yang sesuai dengan tingkat kemampuan bahasa Inggrismu." },
    ],
  }
];

const faqPages = faqItems.reduce((pages, item, index) => {
  const pageIndex = Math.floor(index / 5);

  if (!pages[pageIndex]) {
    pages[pageIndex] = [];
  }

  pages[pageIndex].push(item);
  return pages;
}, []);

const Signup = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.1 });
  const [activeFaqId, setActiveFaqId] = useState(faqItems[0].id);
  const [currentFaqPage, setCurrentFaqPage] = useState(0);
  const [faqPageDirection, setFaqPageDirection] = useState("next");

  const toggleFaq = (id) => {
    setActiveFaqId((prev) => (prev === id ? null : id));
  };

  const currentFaqItems = faqPages[currentFaqPage] ?? [];

  const goToFaqPage = (pageIndex) => {
    if (pageIndex < 0 || pageIndex >= faqPages.length || pageIndex === currentFaqPage) {
      return;
    }

    setFaqPageDirection(pageIndex > currentFaqPage ? "next" : "prev");
    setCurrentFaqPage(pageIndex);
    setActiveFaqId(null);
  };

  return (
    <section id="signup" className="st-surface-cream px-4 py-14 sm:py-16" ref={ref}>
      <div className="mx-auto w-full max-w-6xl">
        <div className="mb-10 sm:mb-12">
          <div className="grid gap-4 md:grid-cols-[1fr_auto] md:items-end">
            <h2 className="st-font-display text-[46px] leading-[0.98] text-[#2f2b2b] sm:text-[56px] lg:text-[64px]">
              <span className="italic">Masih</span> <span className="font-bold">ragu</span> <span className="italic">untuk</span>
              <br />
              <span className="font-bold">mulai?</span>
            </h2>

            <p className="st-font-body max-w-[320px] text-[20px] leading-[1.25] text-[#3a3736] sm:text-[22px] md:text-right lg:text-[24px]">
              Siap bantu kamu milih program yang tepat
            </p>
          </div>

          <div className="mt-8">
            <div className="overflow-hidden">
              <div
                key={currentFaqPage}
                className={`space-y-3 ${faqPageDirection === "next" ? "animate-faq-page-in-right" : "animate-faq-page-in-left"}`}
              >
                {currentFaqItems.map((item) => {
                  const isOpen = activeFaqId === item.id;

                  return (
                    <div key={item.id} className="overflow-hidden rounded-[4px] border-l-[4px] border-l-[#b8b8b8] bg-[#d8d8d8]">
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        aria-controls={`${item.id}-panel`}
                        onClick={() => toggleFaq(item.id)}
                        className="st-focus-ring st-font-body flex w-full items-center justify-between px-4 py-3 text-left text-[18px] font-semibold leading-[1.25] text-[#1d1d1d] sm:px-5 sm:py-4 sm:text-[20px] lg:text-[22px]"
                      >
                        <span>{item.question}</span>
                      </button>

                      <div
                        id={`${item.id}-panel`}
                        className={`grid transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                      >
                        <div className="overflow-hidden">
                          <p className="st-font-body px-4 pb-4 text-[16px] leading-[1.4] text-[#262626] sm:px-5 sm:pb-5 sm:text-[18px] lg:text-[20px]">
                            {item.answerParts.map((part, index) => (
                              <React.Fragment key={`${item.id}-part-${index}`}>
                                {part.bold ? <strong>{part.text}</strong> : part.text}
                                {index < item.answerParts.length - 1 ? " " : ""}
                              </React.Fragment>
                            ))}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {faqPages.length > 1 ? (
              <div className="mt-5 flex items-center justify-center gap-3 sm:gap-4">
                <button
                  type="button"
                  onClick={() => goToFaqPage(currentFaqPage - 1)}
                  disabled={currentFaqPage === 0}
                  aria-label="FAQ sebelumnya"
                  className="st-focus-ring flex h-11 w-11 items-center justify-center rounded-full border border-[#c9c0b5] bg-[#f4ebe0] text-[#2f2b2b] transition hover:bg-[#efe2d4] disabled:cursor-not-allowed disabled:opacity-40"
                >
                  <span aria-hidden="true" className="text-[64px] leading-none -translate-y-2">‹</span>
                </button>

                <div className="st-font-body min-w-[72px] rounded-full border border-[#c9c0b5] bg-[#f4ebe0] px-4 py-2 text-center text-[16px] font-semibold text-[#2f2b2b] sm:text-[17px]">
                  {currentFaqPage + 1} / {faqPages.length}
                </div>

                <button
                  type="button"
                  onClick={() => goToFaqPage(currentFaqPage + 1)}
                  disabled={currentFaqPage === faqPages.length - 1}
                  aria-label="FAQ berikutnya"
                  className="st-focus-ring flex h-11 w-11 items-center justify-center rounded-full border border-[#c9c0b5] bg-[#f4ebe0] text-[#2f2b2b] transition hover:bg-[#efe2d4] disabled:cursor-not-allowed disabled:opacity-40"
                >
                  <span aria-hidden="true" className="text-[64px] leading-none -translate-y-2">›</span>
                </button>
              </div>
            ) : null}
          </div>
        </div>

        <div className={`st-signup-panel rounded-[34px] px-6 py-12 text-center sm:px-10 sm:py-14 ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
          <h2 className="st-font-display text-[44px] leading-[1.08] text-[#FFF7EB] sm:text-[54px] lg:text-[62px]">
            <span className="italic">Start Your</span> <span className="font-bold">IELTS</span>
            <br />
            <span className="font-bold">Journey</span> <span className="italic">Today</span>
          </h2>

          <p className="st-font-body mx-auto mt-5 max-w-3xl text-[18px] leading-[1.35] text-[#E5E5E7] sm:text-[20px] lg:text-[22px]">
            Achieve Your Target Score with the Right Strategy
          </p>

          <a
            href="https://wa.me/+6288228773929?text=Halo,%20saya%20mau%20mulai%20diskusi"
            target="_blank"
            rel="noopener noreferrer"
            className="st-btn-base st-btn-blue st-focus-ring mt-8 h-12 px-8 text-[22px] font-bold sm:h-14 sm:px-10 sm:text-[24px]"
          >
            Start Here
          </a>

          <p className="st-font-body mt-3 text-[13px] text-[#AAAAAF] sm:text-[14px]">
            Klik untuk mulai diskusi dengan kami ↗
          </p>
        </div>
      </div>
    </section>
  );
};

export default Signup;